export enum EnumQueryMethods {
	COPY = 'COPY',
	DELETE = 'DELETE',
	GET = 'GET',
	PATCH = 'PATCH',
	POST = 'POST',
	PUT = 'PUT',
}
